import { render } from "./MapperDetailView.vue?vue&type=template&id=d67e0f02"
import script from "./MapperDetailView.vue?vue&type=script&lang=js"
export * from "./MapperDetailView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sivasankarelango/Sivasankar/test-cx/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__